export default __webpack_public_path__ + "static/media/Loading.93ffbc77.svg";